import React from 'react';

import { AssetsIcon } from '@atlaskit/temp-nav-app-icons/assets';

import { GlobalShortcutsItem } from '../../types';

export default function assets(
	localizedName: string,
	fallbackUrl: () => string,
): GlobalShortcutsItem {
	return {
		icon: <AssetsIcon size="20" />,
		label: localizedName,
		fallbackUrl,
	};
}
